import React from 'react';
import { Heart, ArrowRight } from 'lucide-react';

const BottomCTA = () => (
  <section className="cta-band" data-testid="bottom-cta">
    <div className="container" style={{ textAlign: 'center' }}>
      <Heart size={30} fill="#fff" style={{ margin: '0 auto 14px' }} />
      <h2>Stop Swiping. Start Connecting.</h2>
      <p className="cta-sub">Your Perfect Match is Just a Form Away.</p>
      <a className="btn btn-cream" href="#match" data-testid="cta-get-match-btn">Get My Match <ArrowRight size={17} /></a>
    </div>
  </section>
);

export default BottomCTA;
